module.exports = __webpack_public_path__ + "static/media/workingmemory-words-8.54d25119.mp3";